import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { trackSignupCompletedOnce } from "@/lib/productAnalytics";

const NEW_ACCOUNT_WINDOW_MS = 5 * 60 * 1000;

function maybeTrackSignup(session: any) {
  const user = session?.user;
  if (!user?.id || !user?.created_at) return;
  const createdAt = Date.parse(user.created_at);
  if (!Number.isFinite(createdAt) || Date.now() - createdAt > NEW_ACCOUNT_WINDOW_MS) return;

  const provider = String(user.app_metadata?.provider || "").toLowerCase();
  const method = provider === "google" ? "google" : provider === "email" ? "email" : "unknown";

  // user.id is used only by trackSignupCompletedOnce as a browser-local dedup
  // key. The analytics payload contains only the coarse auth method.
  trackSignupCompletedOnce(user.id, method);
}

/**
 * One app-wide listener for successful account creation. The local once-key also
 * prevents duplicate events when Supabase emits INITIAL_SESSION + SIGNED_IN.
 */
export default function ProductAnalyticsLifecycle() {
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => maybeTrackSignup(data.session));
    const { data } = supabase.auth.onAuthStateChange((_event, session) => maybeTrackSignup(session));
    return () => data.subscription.unsubscribe();
  }, []);

  return null;
}
